import SimplePicker from 'components/Widgets/SimplePicker';

const YesNoTypeField = ({ selectItem, setNewSelectItem, item, disabled }) => {
  return (
    <SimplePicker
      selected={selectItem.value}
      onChange={(val) =>
        setNewSelectItem({
          value: val ?? ' ',
          setting: {},
        })
      }
      item={item}
      disabled={disabled}
    />
  );
};

export default YesNoTypeField;
